import './hero.css';

import logo from "./../../assets/images/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

const hero = () => {
  return (
    <div className="hero">
      <div className="heroLogoSpace">
        <img className="heroLogo" src={logo} alt="" />
      </div>
      <div className="heroTextSpace">
        <h1 className="heroText">
          INSTALAÇÃO DE SOM AMBIENTE PARA LOCAIS PÚBLICOS E COMERCIAIS EM CURITIBA
          E REGIÃO.
        </h1>
      </div>

      <div className="heroIcons">
        <div className="heroIcon" onClick={() => window.open("https://api.whatsapp.com/send?phone=41996074017")}>
          <FontAwesomeIcon className='contactsPhoneIcon' icon={faWhatsapp}/>
        </div>

        <div className="heroIcon" onClick={() => window.open("https://www.instagram.com/maxsomambiente/")}>
          <FontAwesomeIcon className='contactsInstagramItem' icon={faInstagram} />
        </div>

          <div className="heroIcon" onClick={() => window.open("mailto:maxsomambiente@gmail.com")}>
            <FontAwesomeIcon className='contactsEmailIcon' icon={faEnvelope} />
          </div>
      </div>
    </div>
  );
}

export default hero
